module.exports = __webpack_public_path__ + "img/resetpassword2.c92e6cd.png";